import React from 'react';
import { string, bool } from 'prop-types';
import i18next from 'i18next';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { CHANNEL_ICONS } from './constants';

function ChannelInfo({ channel, showDeliveryTypeAsText }) {
  if (!CHANNEL_ICONS[channel]) {
    return null;
  }

  return (
    <Stack spacing={1} direction="row">
      {showDeliveryTypeAsText ? (
        <>
          {i18next.t(`DeliveryStatus:app`)} {i18next.t(`DeliveryStatus:${CHANNEL_ICONS[channel].appName}`)}
        </>
      ) : (
        <>
          <img src={CHANNEL_ICONS[channel].icon} width="32" height="32" />
          <Stack alignItems="flex-start">
            <Typography fontWeight="fontWeightBold" variant="caption" sx={{ lineHeight: '1.3' }}>
              {i18next.t(`DeliveryStatus:app`)}
            </Typography>
            <Typography fontWeight="fontWeightBold" variant="caption" sx={{ lineHeight: '1.3' }}>
              {i18next.t(`DeliveryStatus:${CHANNEL_ICONS[channel].appName}`)}
            </Typography>
          </Stack>
        </>
      )}
    </Stack>
  );
}

ChannelInfo.propTypes = {
  channel: string,
  showDeliveryTypeAsText: bool
};

export { ChannelInfo };
